<template>
  <aside class="menu app-sidebar nav-menu">
    <p class="menu-label">Menu</p>
    <ul class="menu-list">
      <li><router-link to="/" exact><span class="icon"><i class="fa fa-tachometer"></i></span> Dashboard</router-link></li>
      <li><router-link to="/products"><span class="icon"><i class="fa fa-briefcase"></i></span> Products</router-link></li>
      <li><router-link to="/clients"><span class="icon"><i class="fa fa-lg fa-mobile"></i></span> Applications</router-link></li>
      <li><router-link to="/users"><span class="icon"><i class="fa fa-users"></i></span> Users</router-link></li>
    </ul>
    <div class="is-hidden-desktop">
      <hr>
      <p class="menu-label">
        <span class="icon"><i class="fa fa-lg fa-user-circle-o" aria-hidden="true"></i></span>
        {{ this.$store.state.customer.name }}
      </p>
      <ul class="menu-list">
        <li><a v-on:click="logout"><span class="icon"><i class="fa fa-lg fa-sign-out"></i></span>Log out</a></li>
      </ul>
    </div>
    <div class="menu-bottom has-text-centered has-text-grey">
      <p class="is-size-7">IoT Console</p>
      <p class="is-size-7">by <a href="https://fusionnextinc.com/">Fusion Next Inc.</a></p>
    </div>
  </aside>
</template>

<script>
  export default {
    methods: {
      logout: function (event) {
        if (event) event.preventDefault()

        this.$store.commit('LOGOUT')
        this.$store.commit('SET_AUTHENTICATED', false)

        window.localStorage.clear()
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .app-sidebar {
    position: fixed;
    top: 52px;
    left: 0;
    bottom: 0;
    padding: 20px 0 50px;
    width: 180px;
    min-width: 45px;
    max-height: 100vh;
    height: calc(100% - 50px);
    z-index: 1024 - 1;
    background: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: auto;
    overflow-x: hidden;

    .menu-label {
      padding-left: 5px;
    }

    .menu-list {
      li a {
        &[aria-expanded="true"] {
          .is-angle {
            transform: rotate(180deg);
          }
        }
      }

      li a + ul {
        margin: 0 10px 0 15px;
      }
    }
  }

  .menu-bottom {
    position: absolute;
    width: 100%;
    bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?f96f7abe